export default __webpack_public_path__ + "static/media/icon_arrow_right.6f470b49.svg";